import { render, staticRenderFns } from "./Small.vue?vue&type=template&id=6779852d&scoped=true&"
import script from "./Small.vue?vue&type=script&lang=js&"
export * from "./Small.vue?vue&type=script&lang=js&"
import style0 from "./Small.vue?vue&type=style&index=0&id=6779852d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6779852d",
  null
  
)

export default component.exports